import { Component } from '@angular/core';

@Component({
  selector: 'app-bilan-rse',
  templateUrl: './bilan-rse.component.html',
  styleUrls: ['./bilan-rse.component.scss']
})
export class BilanRseComponent {
  pdfUrl = 'https://cdn.blackrockgames.fr/catalogs/bilan_RSE.pdf?v=' + Date.now();
}
